import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/act-github/",
          "title": "Deploy to GitHub Pages"
        }}>{`A snippet`}</MDXTag>{` with instructions how to deploy an ACT website to GitHub Pages using a `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://github.com/tschaub/gh-pages"
        }}>{`gh-pages`}</MDXTag>{` package`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`# add a gh-pages package
npm install gh-pages --save-dev
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`For GitHub Organization or User pages (repository `}<MDXTag name="em" components={components} parentName="p">{`username.github.io`}</MDXTag>{`), a simple deploy script should be added to `}<MDXTag name="em" components={components} parentName="p">{`package.json`}</MDXTag></MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// package.json
    {
        "scripts": {
            ...
            "deploy": "gatsby build && gh-pages -d public -b master",
        }
    }
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`For repository pages (URLs of the form `}<MDXTag name="inlineCode" components={components} parentName="p">{`https://username.github.io/reponame/`}</MDXTag>{`), an additional prefix should be added as well.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// package.json
    {
        "scripts": {
            ...
            "deploy": "gatsby build --prefix-paths && gh-pages -d public -b master",
        }
    }
`}</MDXTag></MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// gatsby-config.js
module.exports = {
    pathPrefix: "/reponame",
}
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Deploy ACT to GitHub Pages",
  "keywords": "ACT, deploy, GitHub Pages",
  "menu": "act blog/deploy github"
};
    